import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const sparklesUrls = [
    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_5.svg`,
    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_4.svg`,
    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_3.svg`,
    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_2.svg`,
    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_1.svg`,
];
const greetingColors = [
    "#C7BB88",
    "#80C3B9",
    "#E4939F",
    "#94B3BF",
    "#BF8BAF",
    "#DD9683",
];
export const birthdayCake = {
    version: 1,
    themeId: "birthday-cake",
    name: "Birthday Cake",
    endFadeDuration: 1,
    thumbnailFrame: 130,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/birthday-cake.webp`,
    background: [
        {
            variant: "image",
            src: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/paper_texture.png`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/optimized/paper_texture.jpg`,
            },
        },
    ],
    scenes: [
        {
            type: "birthdayCakeIntro",
            lottieUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/intro.json`,
            durationSeconds: 6.5,
            faceCollage: {
                variant: "grid-bounce",
                faceCollageSceneDurationSeconds: 10,
            },
            title: {
                fontFamily: "Satisfy",
                fontSize: 160,
                fontWeight: "medium",
                textColor: "#fff",
            },
            sparklesUrls: [
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_5.svg`,
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_4.svg`,
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_3.svg`,
            ],
        },
        {
            type: "circleGreeting",
            variant: "intro",
            sparklesUrls,
            colors: greetingColors,
            showLogo: true,
        },
        {
            type: "clip-series-basic",
            exitTransition: {
                variant: "slide",
                direction: "from-top",
                timing: {
                    variant: "linear",
                    durationSeconds: 0.25,
                    easing: "easeIn",
                },
            },
            showLogo: true,
            sceneBackground: {
                variant: "sparkles",
                urls: [
                    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_5.svg`,
                    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_4.svg`,
                    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_3.svg`,
                    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_2.svg`,
                    `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/cake/Star_1.svg`,
                ],
            },
        },
        {
            type: "circleGreeting",
            variant: "outro",
            sparklesUrls,
            colors: greetingColors,
            showLogo: true,
        },
        {
            type: "lottieOutro",
            durationSeconds: 7,
            lottieUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-cake/intro.json`,
            logo: {
                position: "right",
                transition: "slide-down",
            },
            lottiePosition: "left",
            showLogo: true,
        },
    ],
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name",
            defaultValue: "",
            placeholder: "Sarah",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 90,
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0.1,
            backgroundBlur: 2,
            textAlign: "center",
            fontFamily: "Satisfy",
            fontSize: 160,
            fontWeight: "medium",
            textColor: "#fff",
            leading: 1.1,
            tracking: 0.05,
        },
        clips: {
            betweenTransition: {
                variant: "slide",
                direction: "from-top",
                timing: {
                    variant: "spring",
                    config: { mass: 1.75, stiffness: 50, damping: 12 },
                    durationSeconds: 1,
                },
            },
            textVariant: {
                variant: "circle",
                colors: [
                    "#C7BB88",
                    "#80C3B9",
                    "#E4939F",
                    "#94B3BF",
                    "#BF8BAF",
                    "#DD9683",
                ],
            },
            backgroundVariant: {
                variant: "circle",
                colors: [
                    "#C7BB88",
                    "#80C3B9",
                    "#E4939F",
                    "#94B3BF",
                    "#BF8BAF",
                    "#DD9683",
                ],
            },
            borderRadius: "10rem",
            scaleFactor: 0.85,
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Satisfy",
                fontWeight: "medium",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Futura",
                fontWeight: "medium",
                fontSize: 48,
                nudge: 2,
                textTransform: "none",
            },
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 1 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 1 },
            },
        },
        sceneTransition: {
            variant: "slide",
            direction: "from-top",
            timing: {
                variant: "spring",
                config: { mass: 1.75, stiffness: 50, damping: 12 },
                durationSeconds: 1,
            },
        },
    },
};
